// Library Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// Local Imports
import axios from "../../network/https";

// Initial state for Contract History
const initialState = {
  contractHistory: [],
  currentContractIndex: 0,
  loading: false,
  error: null,
};

// Fetch Contract History API Function
export const fetchContractHistory = createAsyncThunk(
  "contractHistory/fetch",
  async (channelId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `/v1/chat/channels/${channelId}/contracts/`
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch contract history"
      );
    }
  }
);

// Reducers
export const contractHistorySlice = createSlice({
  name: "contractHistory",
  initialState,
  reducers: {
    setCurrentContractIndex: (state, action) => {
      state.currentContractIndex = action.payload;
    },
    refreshContractHistory: (state, action) => {
      // This action will be dispatched when a new contract is generated
      // or when a contract status is updated
      if (action.payload && action.payload.contract) {
        // Check if the contract already exists in the history
        const existingIndex = state.contractHistory.findIndex(
          (contract) => contract.id === action.payload.contract.id
        );

        if (existingIndex >= 0) {
          // Update the existing contract
          state.contractHistory[existingIndex] = action.payload.contract;
        } else {
          // Add the new contract to the beginning of the array
          state.contractHistory = [
            action.payload.contract,
            ...state.contractHistory,
          ];
          state.currentContractIndex = 0; // Set to the newest contract
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContractHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.contractHistory = action.payload || [];
        state.currentContractIndex = 0; // Reset to the first (newest) contract
        state.error = null;
      })
      .addCase(fetchContractHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentContractIndex, refreshContractHistory } =
  contractHistorySlice.actions;
export default contractHistorySlice.reducer;
